module.exports = __webpack_public_path__ + "static/media/img3-1.2d245282.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pina/nutricheck_foliar/CA/img3-1.png
// module id = 2307
// module chunks = 3